import { Static, Type } from '@sinclair/typebox'
import { KizeoTenantTier } from '../policy/tenant-policy'

export const KizeoTenantSyncTrigger = Type.Union([
    Type.Literal('cron'),
    Type.Literal('manual'),
])
export type KizeoTenantSyncTrigger = Static<typeof KizeoTenantSyncTrigger>

// Current sync state, one row per Kizeo-linked tenant (upserted on every sync,
// no history). Tenants that were never synced have no row.
export const KizeoTenantSyncState = Type.Object({
    tenantId: Type.String(),
    lastKnownTier: KizeoTenantTier,
    lastSyncedAt: Type.String(),
    lastSyncTrigger: KizeoTenantSyncTrigger,
})
export type KizeoTenantSyncState = Static<typeof KizeoTenantSyncState>
